// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ce62a7e6","732":"9a083413","977":"d7c42401"}[chunkId] + ".chunk.js";
};